module.exports = __webpack_public_path__ + "static/assets/8c830383cc16e94714524dcf8c68f269.png";